import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

// eslint-disable-next-line import/prefer-default-export
export const BusinessOption = styled(Button, {
  shouldForwardProp: prop => prop !== 'selected',
})(({ theme, selected }) => ({
  border: `1px solid ${theme.palette.grey[200]}`,
  color: theme.palette.text.primary,
  padding: theme.spacing(1.5, 2),
  width: '100%',
  justifyContent: 'start',

  '&:hover, &:focus, &:active': {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.light,
  },

  ...(selected && {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.light,
  }),
}));
